// extracted by mini-css-extract-plugin
module.exports = {"button_loader":"button-loader_button_loader__tDHsx","bounce":"button-loader_bounce__23e8P","rotate":"button-loader_rotate__tEgfy"};